import withStyles from '@mui/styles/withStyles';
import { tokens } from './design/theme.next';

const styles = theme => ({
  "@global": {
    /**
     * Custom scrollbar styling for WebKit browsers
     */
    "*::-webkit-scrollbar": {
      width: "8px",
      height: "8px",
    },
    "*::-webkit-scrollbar-track": {
      background: "transparent",
    },
    "*::-webkit-scrollbar-thumb": {
      background: theme.palette.mode === "dark" 
        ? "rgba(255, 255, 255, 0.2)"
        : "rgba(0, 0, 0, 0.2)",
      borderRadius: "4px",
      "&:hover": {
        background: theme.palette.mode === "dark" 
          ? "rgba(255, 255, 255, 0.3)"
          : "rgba(0, 0, 0, 0.3)",
      },
    },
    "*::-webkit-scrollbar-corner": {
      background: "transparent",
    },
    /**
     * Firefox scrollbar styling
     */
    "*": {
      scrollbarWidth: "thin",
      scrollbarColor: theme.palette.mode === "dark" 
        ? "rgba(255, 255, 255, 0.2) transparent"
        : "rgba(0, 0, 0, 0.2) transparent",
    },
    /**
     * No outline for mouse focus; one violet ring for keyboard focus.
     * Text fields keep their own focused border.
     */
    "*:focus:not(:focus-visible)": {
      outline: 0
    },
    ":focus-visible:not(input):not(textarea):not(select):not([tabindex='-1'])": {
      outline: `2px solid ${tokens.a4.color.violet}`,
      outlineOffset: "2px",
    },
    // Form controls take the page font, not the browser default (Arial).
    "button, input, select, textarea": {
      fontFamily: "inherit",
    },
    ".text-white": {
      color: theme.palette.common.white
    },
    ".listItemLeftPadding": {
      paddingTop: `${theme.spacing(1.75)} !important`,
      paddingBottom: `${theme.spacing(1.75)} !important`,
      paddingLeft: `${theme.spacing(4)} !important`,
      [theme.breakpoints.down('md')]: {
        paddingLeft: `${theme.spacing(4)} !important`
      },
      "@media (max-width:  420px)": {
        paddingLeft: `${theme.spacing(1)} !important`
      }
    },
    ".container": {
      width: "100%",
      paddingRight: theme.spacing(4),
      paddingLeft: theme.spacing(4),
      marginRight: "auto",
      marginLeft: "auto",
      [theme.breakpoints.up("sm")]: {
        maxWidth: 540
      },
      [theme.breakpoints.up("md")]: {
        maxWidth: 720
      },
      [theme.breakpoints.up("lg")]: {
        maxWidth: 1170
      }
    },
    ".row": {
      display: "flex",
      flexWrap: "wrap",
      marginRight: -theme.spacing(2),
      marginLeft: -theme.spacing(2)
    },
    ".container-fluid": {
      width: "100%",
      paddingRight: theme.spacing(2),
      paddingLeft: theme.spacing(2),
      marginRight: "auto",
      marginLeft: "auto",
      maxWidth: 1370
    },
    ".lg-mg-top": {
      marginTop: `${theme.spacing(20)} !important`,
      [theme.breakpoints.down('lg')]: {
        marginTop: `${theme.spacing(18)} !important`
      },
      [theme.breakpoints.down('md')]: {
        marginTop: `${theme.spacing(16)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        marginTop: `${theme.spacing(14)} !important`
      }
    },
    ".lg-mg-bottom": {
      marginBottom: `${theme.spacing(20)} !important`,
      [theme.breakpoints.down('lg')]: {
        marginBottom: `${theme.spacing(18)} !important`
      },
      [theme.breakpoints.down('md')]: {
        marginBottom: `${theme.spacing(16)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        marginBottom: `${theme.spacing(14)} !important`
      }
    },
    ".lg-p-top": {
      paddingTop: `${theme.spacing(20)} !important`,
      [theme.breakpoints.down('lg')]: {
        paddingTop: `${theme.spacing(18)} !important`
      },
      [theme.breakpoints.down('md')]: {
        paddingTop: `${theme.spacing(16)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        paddingTop: `${theme.spacing(14)} !important`
      }
    },
    ".lg-p-bottom": {
      paddingBottom: `${theme.spacing(20)} !important`,
      [theme.breakpoints.down('lg')]: {
        paddingBottom: `${theme.spacing(18)} !important`
      },
      [theme.breakpoints.down('md')]: {
        paddingBottom: `${theme.spacing(16)} !important`
      },
      [theme.breakpoints.down('sm')]: {
        paddingBottom: `${theme.spacing(14)} !important`
      }
    }
  }
});

function globalStyles() {
  return null;
}

export default withStyles(styles, { withTheme: true })(globalStyles);
